import ProductCard from "@/pages/home/components/ProductCard";
import type { Product } from "@/mocks/products";

interface RelatedProductsProps {
  products: Product[];
  onAddToCart: (product: Product) => void;
}

export default function RelatedProducts({ products, onAddToCart }: RelatedProductsProps) {
  if (products.length === 0) return null;

  return (
    <section className="mt-16">
      <div className="flex items-end justify-between">
        <div>
          <h2 className="font-heading text-3xl font-semibold text-foreground-950">
            Você também pode gostar
          </h2>
          <p className="mt-1 text-sm text-foreground-500">
            Selecionamos peças que combinam com o seu estilo
          </p>
        </div>
      </div>

      <div className="mt-7 grid grid-cols-1 gap-x-5 gap-y-8 sm:grid-cols-2 lg:grid-cols-4">
        {products.map((product) => (
          <ProductCard key={product.id} product={product} onAddToCart={onAddToCart} />
        ))}
      </div>
    </section>
  );
}